import { t } from '@/plugins/i18n'
export const getFundColumns: any = (currencyCode: 'KRW'| 'CNY') => [
  {
    label: t('出账 / 入账') + `(${currencyCode === 'KRW' ? t('KRW') : t('元')})`,
    prop: 'changeAmount',
    align: 'center',
    slotName: 'changeAmount'
  },
  {
    label: t('余额') + `(${currencyCode === 'KRW' ? t('KRW') : t('元')})`,
    prop: 'afterAvailableAmount',
    align: 'center'
  },
  {
    label: t('费用类型'),
    prop: 'fundFlowType',
    align: 'center',
    slotName: 'fundFlowType'
  },
  {
    label: t('明细'),
    prop: 'bizContentCustomer',
    align: 'center',
    width: 300,
    slotName: 'bizContentCustomer'
  },
  {
    label: t('流水号'),
    prop: 'fundFlowNo',
    align: 'center'
  },
  {
    label: t('日期'),
    prop: 'updateTime',
    align: 'center',
    slotName: 'updateTime'
  }
]

export const getSubFundColumns: any = (currencyCode: 'KRW'| 'CNY') => [
  {
    label: t('出账 / 入账') + `(${currencyCode === 'KRW' ? t('KRW') : t('元')})`,
    prop: 'changeAmount',
    align: 'center',
    slotName: 'changeAmount'
  },
  {
    label: t('可用余额') + `(${currencyCode === 'KRW' ? t('KRW') : t('元')})`,
    prop: 'afterAvailableAmount',
    align: 'center'
  },
  {
    label: t('费用类型'),
    prop: 'fundFlowType',
    align: 'center',
    slotName: 'fundFlowType'
  },
  {
    label: t('明细'),
    prop: 'bizContentCustomer',
    align: 'center',
    width: 300,
    slotName: 'bizContentCustomer'
  },
  {
    label: t('THE CKB订单编号'),
    prop: 'orderNo',
    align: 'center',
    width: 230,
    slotName: 'orderNo'
  },
  // {
  //   label: t('订单标题'),
  //   prop: 'orderTitle',
  //   align: 'center',
  //   width: 150
  // },
  {
    label: t('THE CKB发货单号'),
    prop: 'deliverOrderNo',
    align: 'center',
    width: 230,
    slotName: 'deliverOrderNo'
  },
  // {
  //   label: t('发货标题'),
  //   prop: 'deliverTitle',
  //   align: 'center',
  //   width: 150
  // },
  {
    label: t('流水号'),
    prop: 'fundFlowNo',
    align: 'center'
  },
  {
    label: t('日期'),
    prop: 'updateTime',
    align: 'center',
    slotName: 'updateTime'
  }
]

export const tableConfig = {
  showHandler: true,
  handlerConfig: { minWidth: 120, fixed: false },
  setHeight: true,
  height: 600
}

export const changeTypeDict = {
  1: t('出账'),
  2: t('入账')
}

export const formatPrice = (price: any) => String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
export const plusPrice = (price: any) => price ? '+' + price : 0
export const reducePrice = (price: any) => price ? '-' + price : 0
export const platformOrderItemSettleTypeDict: any = {
  1: t('冻结'),
  2: t('解冻'),
  3: t('结算'),
  4: t('重拍冻结')
}

export const setFixed2 = (total: any) => {
  return total > 0 ? Number(total.toFixed(2)) : 0
}

export const historyColumns = [
  { prop: 'fundFlowNo', label: t('流水号'), slotName: 'fundFlowNo' },
  {
    prop: 'balanceRechargeStatus',
    label: t('状态'),
    slotName: 'balanceRechargeStatus'
  },
  {
    prop: 'remittanceAmount',
    label: t('存入金额'),
    slotName: 'remittanceAmount'
  },
  {
    prop: 'payChannel',
    label: t('明细'),
    slotName: 'payChannel'
  },
  { prop: 'refuseReason', label: t('拒绝原因') },
  {
    prop: 'rechargeArrivalTime',
    label: t('日期'),
    width: 200,
    slotName: 'rechargeArrivalTime'
  }
]

export const secondFlowType = {
  // 余额充值
  1: [
    {
      name: 'paypal',
      value: ''
    },
    {
      name: 'payoneer',
      value: ''
    },
    {
      name: t('銀行振込'),
      value: ''
    }
  ],
  // // 提现
  // 2: [
  //   {
  //     name: '銀行振込',
  //     value: ''
  //   }
  // ],
  // // 提现失败
  // 21: [
  //   {
  //     name: '銀行振込',
  //     value: ''
  //   }
  // ],
  // 转入 店铺
  10: [],
  // 转出 店铺
  11: [],
  // 会员费 会员类型
  12: [],
  // 手续费
  6: [
    {
      name: t('OEM发起寻源')
    },
    {
      name: t('既成品采购费')
    },
    {
      name: t('市场商品采购费')
    },
    {
      name: t('有缺陷的产品退货')
    },
    {
      name: t('次品重买')
    },
    {
      name: t('OEM批量生产')
    },
    {
      name: t('OEM样品订单')
    },
    {
      name: t('商品组合')
    },
    // {
    //   name: t('保管料')
    // },
    {
      name: t('入库费')
    },
    {
      name: t('出库费')
    },
    {
      name: t('组合返工')
    },
    {
      name: t('库存保管费')
    },
    {
      name: t('包裹滞留费')
    },
    {
      name: t('关税报销')
    },
    {
      name: t('出库(含国际运费)')
    }
  ],
  // 商品附加项
  15: [
    {
      name: t('水洗标制作')
    },
    {
      name: t('简易检品')
    },
    {
      name: t('详细检品')
    },
    {
      name: t('开扣眼')
    },
    {
      name: t('缝布标')
    },
    {
      name: t('缝水洗标')
    },
    {
      name: t('去原标（水洗标、布标、吊牌）')
    },
    {
      name: t('首饰台纸')
    },
    {
      name: t('检针服务')
    },
    {
      name: t('熨烫')
    },
    {
      name: t('除味')
    },
    {
      name: t('感谢卡（检品时放在每件商品内）')
    },
    {
      name: t('丝带包装（检品时放在每件商品内）')
    },
    {
      name: t('雪梨纸包装（检品时放在每件商品内）')
    },
    {
      name: t('吊り札掛け')
    },
    {
      name: t('通电检查')
    },
    {
      name: t('刮刮卡（检品时放在每件商品内）')
    },
    {
      name: t('优惠券（检品时放在每件商品内）')
    },
    {
      name: t('保证卡（检品时放在每件商品内）')
    },
    {
      name: t('说明书')
    },
    {
      name: t('普通OPP袋')
    },
    {
      name: t('定制OPP袋')
    },
    {
      name: t('特殊收纳袋')
    },
    {
      name: t('其他物料放置（检品时放在每件商品内）')
    },
    {
      name: t('尺寸测量服务')
    },
    {
      name: t('气泡膜')
    },
    {
      name: t('商品缠绕膜服务')
    },
    {
      name: t('商品缓冲垫服务')
    },
    {
      name: t('穿吊牌')
    },
    {
      name: t('剪原标')
    },
    {
      name: t('剪布标')
    },
    {
      name: t('剪水洗标')
    },
    {
      name: t('剪吊牌')
    },
    {
      name: t('尺寸变更(缝尺码标)')
    },
    {
      name: t('尺寸变更(尺码贴)')
    },
    {
      name: t('宽松检品')
    },
    {
      name: t('圧縮袋梱包')
    },
    {
      name: t('新商品服务')
    }

  ],
  16: [
    {
      name: t('感谢卡（发货时放在每个包裹里）')
    },
    {
      name: t('丝带包装（发货时放在每个包裹里）')
    },
    {
      name: t('纸板外箱')
    },
    {
      name: t('装箱服务')
    },
    {
      name: t('气泡膜')
    },
    {
      name: t('贴标')
    },
    {
      name: t('打托盘')
    },
    {
      name: t('雪梨纸包装（发货时放在每个包裹里）')
    },
    {
      name: t('刮刮卡（发货时放在每个包裹里）')
    },
    {
      name: t('优惠券（发货时放在每个包裹里）')
    },
    {
      name: t('保证卡（发货时放在每个包裹里）')
    },
    {
      name: t('其他物料放置（发货时放在每个包裹里）')
    },
    {
      name: t('发货袋-普通快递袋')
    },
    {
      name: t('自有品牌运输袋')
    },
    {
      name: t('商品打木架')
    },
    {
      name: t('贴箱唛')
    }
  ],
  // 次转正
  27: [
    {
      name: t('水洗标制作')
    },
    {
      name: t('简易检品')
    },
    {
      name: t('详细检品')
    },
    {
      name: t('开扣眼')
    },
    {
      name: t('缝布标')
    },
    {
      name: t('缝水洗标')
    },
    {
      name: t('去原标（水洗标、布标、吊牌）')
    },
    {
      name: t('首饰台纸')
    },
    {
      name: t('检针服务')
    },
    {
      name: t('熨烫')
    },
    {
      name: t('除味')
    },
    {
      name: t('感谢卡（检品时放在每件商品内）')
    },
    {
      name: t('丝带包装（检品时放在每件商品内）')
    },
    {
      name: t('雪梨纸包装（检品时放在每件商品内）')
    },
    {
      name: t('吊り札掛け')
    },
    {
      name: t('通电检查')
    },
    {
      name: t('刮刮卡（检品时放在每件商品内）')
    },
    {
      name: t('优惠券（检品时放在每件商品内）')
    },
    {
      name: t('保证卡（检品时放在每件商品内）')
    },
    {
      name: t('说明书')
    },
    {
      name: t('普通OPP袋')
    },
    {
      name: t('定制OPP袋')
    },
    {
      name: t('特殊收纳袋')
    },
    {
      name: t('其他物料放置（检品时放在每件商品内）')
    },
    {
      name: t('尺寸测量服务')
    },
    {
      name: t('气泡膜')
    },
    {
      name: t('商品缠绕膜服务')
    },
    {
      name: t('穿吊牌')
    },
    {
      name: t('剪原标')
    },
    {
      name: t('剪布标')
    },
    {
      name: t('剪水洗标')
    },
    {
      name: t('剪吊牌')
    },
    {
      name: t('尺寸变更(缝尺码标)')
    },
    {
      name: t('尺寸变更(尺码贴)')
    },
    {
      name: t('宽松检品')
    },
    {
      name: t('圧縮袋梱包')
    }

  ]
}
